import React, { Component } from 'react';
import carouselImg from "../assets/img/carousel-1.jpg";
import networking from "../assets/img/switch-rack.jpg";
import cctv from "../assets/img/cctv.jpg";
import infrastructure from "../assets/img/server-rack.jpg";

export class KeyAreas extends Component {
    static displayName = KeyAreas.name;

    render() {
        return (
            <div>

                {/*Key Areas navbar starts here*/}
                <div class="container-fluid position-relative p-0">
                    <div class="container-fluid bg-primary py-5 bg-header">
                        <div class="row py-5">
                            <div class="col-12 pt-lg-5 mt-lg-5 text-center animated zoomIn">
                                <h3 class="text-capitalize text-white animated zoomIn">key areas</h3>
                                <a class="h5 text-white">Home</a>
                                <i class="bi bi-chevron-right text-white px-2"></i>
                                <a class="h5 text-white">Key Areas</a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Key Areas navbar ends here*/}

                {/*Key Areas section starts here*/}
                {/*Key Areas section starts here*/}
                <div class="container-fluid py-3 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="container py-2">
                        <div class="row g-5">
                            <div class="col-lg-12">
                                <div class="section-title position-relative pb-3 mb-2">
                                    <h5 class="fw-bold text-primary text-uppercase">Core Expertise</h5>
                                    <h1 class="text-capitalize mb-0">Enterprise ICT Solutions</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ======= Core Expertise Section ======= */}
                <section id="key-areas" class="portfolio">
                    <div class="container">

                        <div class="row portfolio-container">

                            {/* Computer Networking */}
                            <div class="col-lg-4 col-md-6 portfolio-item">
                                <p class="mb-4">
                                    <h5 class="fw-bold text-primary text-uppercase">
                                        Computer Networking
                                    </h5>

                                    We design, install and maintain secure enterprise networks
                                    including structured cabling, switches, routers, wireless
                                    networks, VLANs and network security solutions that ensure
                                    reliable connectivity for organizations.
                                </p>

                                <div class="portfolio-wrap">
                                    <img src={networking} class="img-fluid" alt="Computer Networking" />

                                    <div class="portfolio-info">
                                        <h4>Computer Networking</h4>
                                        <p>Enterprise Networks</p>

                                        <div class="portfolio-links">
                                            <a href={networking}
                                                data-gallery="portfolioGallery"
                                                class="portfolio-lightbox"
                                                title="Computer Networking">
                                                <i class="bi bi-plus"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* CCTV */}
                            <div class="col-lg-4 col-md-6 portfolio-item">
                                <p class="mb-4">
                                    <h5 class="fw-bold text-primary text-uppercase">
                                        CCTV & Access Control
                                    </h5>

                                    We install CCTV surveillance, biometric access control,
                                    attendance systems and integrated security solutions that
                                    protect businesses, schools, hospitals and commercial
                                    buildings.
                                </p>

                                <div class="portfolio-wrap">
                                    <img src={cctv} class="img-fluid" alt="CCTV" />

                                    <div class="portfolio-info">
                                        <h4>CCTV & Access Control</h4>
                                        <p>Security Solutions</p>

                                        <div class="portfolio-links">
                                            <a href={cctv}
                                                data-gallery="portfolioGallery"
                                                class="portfolio-lightbox"
                                                title="CCTV & Access Control">
                                                <i class="bi bi-plus"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* IT Infrastructure */}
                            <div class="col-lg-4 col-md-6 portfolio-item">
                                <p class="mb-4">
                                    <h5 class="fw-bold text-primary text-uppercase">
                                        IT Infrastructure Management
                                    </h5>

                                    We deploy and manage enterprise servers, VMware
                                    virtualization, enterprise storage, backup &
                                    replication, ensuring maximum uptime, performance
                                    and business continuity.
                                </p>

                                <div class="portfolio-wrap">
                                    <img src={infrastructure} class="img-fluid" alt="Infrastructure" />

                                    <div class="portfolio-info">
                                        <h4>IT Infrastructure</h4>
                                        <p>Enterprise Solutions</p>

                                        <div class="portfolio-links">
                                            <a href={infrastructure}
                                                data-gallery="portfolioGallery"
                                                class="portfolio-lightbox"
                                                title="IT Infrastructure">
                                                <i class="bi bi-plus"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
                {/*< !-- ========= End of Key Areas Section ========= -->*/}

            </div>
        );
    }
}
